import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function Announcement({ inputRef }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      const existing = JSON.parse(localStorage.getItem('sc_waitlist') || '[]');
      if (!existing.includes(email)) existing.push(email);
      localStorage.setItem('sc_waitlist', JSON.stringify(existing));
      toast.success("You're on the list. Issue 001 lands in your inbox.");
      setEmail('');
      setSubmitting(false);
    }, 500);
  };

  return (
    <div className="max-w-2xl animate-fade-up delay-2">
      <div className="text-[10px] tracking-[0.28em] uppercase text-neutral-500 mb-6">
        An Announcement
      </div>

      <h1 className="font-serif text-[44px] md:text-[68px] lg:text-[80px] leading-[0.98] tracking-[-0.02em] text-neutral-900">
        <span className="relative inline-block text-neutral-400">
          <span>Confidential</span>
          <span className="absolute left-0 right-0 top-1/2 h-[2px] bg-neutral-400/70 -translate-y-1/2"></span>
        </span>{' '}
        <span className="italic font-serif">is now</span>
        <br />
        Startup Culture.
      </h1>

      <p className="mt-8 text-neutral-600 text-[15px] md:text-[17px] leading-relaxed max-w-xl">
        Same obsession. New chapter. A weekly publication for the people
        building things — told through the unfiltered stories of the founders
        living it.
      </p>

      <form onSubmit={submit} className="mt-8 flex items-stretch max-w-lg">
        <input
          ref={inputRef}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@domain.com"
          className="flex-1 bg-transparent border-b border-neutral-400/60 focus:border-neutral-900 outline-none px-1 py-3 text-[15px] text-neutral-900 placeholder:text-neutral-400 transition-colors"
        />
        <button
          type="submit"
          disabled={submitting}
          className="ml-3 group inline-flex items-center gap-2 bg-neutral-900 hover:bg-[#EA580C] text-[#F5F2EC] px-5 py-3 text-[13px] tracking-wide rounded-sm transition-colors duration-300 disabled:opacity-60"
        >
          {submitting ? 'Joining…' : 'Join waitlist'}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </button>
      </form>

      <div className="mt-4 text-[11px] tracking-wide text-neutral-500">
        No spam. One story a week. Unsubscribe anytime.
      </div>
    </div>
  );
}
